/**
 * Product type constants used across DASH (reports + lightweight products).
 */
export const PRODUCT_TYPE_IIR = {value: 'iir', label: 'IIR'};
export const PRODUCT_TYPE_FINTEL = {value: 'analytic', label: 'Analytic Product'};
export const PRODUCT_TYPE_COLLECTION_MATERIAL = {value: 'collection_material', label: 'Collected Material'};

export const COVERAGE_PRODUCT_TYPES = [
    PRODUCT_TYPE_FINTEL,
    PRODUCT_TYPE_IIR,
];

/** Compact badge labels for Products search result chips (next to the "Products" provenance badge). */
const PRODUCT_TYPE_BADGE_LABELS = Object.freeze({
    analytic: 'FINTEL',
    fintel: 'FINTEL',
    iir: 'IIR',
    pitch: 'Pitch',
    tactical_sitrep: 'Tactical SITREP',
    strategic_sitrep: 'Strategic SITREP',
    disclosure: 'Disclosure',
    ndp1_disclosure: 'Disclosure',
    collection_material: 'CM',
});

export function isIirProductType(productType) {
    const value = typeof productType === 'string' ? productType : productType?.value;
    return value === 'iir';
}

export function isCollectionMaterialProductType(productType) {
    const value = typeof productType === 'string' ? productType : productType?.value;
    return value === 'collection_material';
}

/**
 * Short label for a product-type chip on search / source cards.
 * @param {string|{value?: string, label?: string}|null|undefined} productType
 * @returns {string|null}
 */
export function productTypeBadgeLabel(productType) {
    const value = typeof productType === 'string'
        ? productType.trim()
        : (productType?.value != null ? String(productType.value).trim() : '');
    if (!value) return null;
    const key = value.toLowerCase();
    if (PRODUCT_TYPE_BADGE_LABELS[key]) return PRODUCT_TYPE_BADGE_LABELS[key];
    // Fallback: humanize unknown snake_case values (e.g. custom_product → Custom product)
    const fromLabel = typeof productType === 'object' && productType?.label
        ? String(productType.label).trim()
        : '';
    if (fromLabel) return fromLabel;
    return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
